import { render, staticRenderFns } from "./shop-category.vue?vue&type=template&id=9be71716&scoped=true&%3Akey=%24route.fullPath"
import script from "./shop-category.vue?vue&type=script&lang=js"
export * from "./shop-category.vue?vue&type=script&lang=js"
import style0 from "./shop-category.vue?vue&type=style&index=0&id=9be71716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be71716",
  null
  
)

export default component.exports